<template>
    <div class="print-section">
      <link
          rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"
          integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T"
          crossorigin="anonymous"
      />
        <main v-if="surat_tagihan !== null" class="piutang-main-font mx-5 my-6">
            <section class="d-flex">
                <div class="col-8 p-0">
                    <h4 class="text-uppercase">{{ surat_tagihan.perusahaan.nama_perusahaan }}</h4>
                </div>
                <div class="p-0 col-4 d-flex justify-content-end text-right">
                    <p class="">{{ surat_tagihan.perusahaan.alamat_pkp }}</p>
                </div>
            </section>
            <section>
                <p class="piutang-p-style line-break" style=" text-transform: capitalize;">{{kabupatenCompany}}, {{ dFormat(surat_tagihan.tanggal_surat, 'dMY') }}</p>
            </section>

            <section class="line-break d-flex justify-content-between">
                <div class="col-8 p-0">
                    <div class="line-break">
                        <div class="d-flex">
                            <p class="piutang-p-style col-2 m-0">No</p>
                            <p class="piutang-p-style col-10 m-0">: {{ surat_tagihan.nomor_surat }}</p>
                        </div>
                        <div class="d-flex">
                            <p class="piutang-p-style col-2 m-0">Hal</p>
                            <p class="piutang-p-style col-10 m-0">: SURAT KONFIRMASI PIUTANG DAGANG</p>
                        </div>
                        <div class="d-flex">
                            <p class="piutang-p-style col-2 m-0">Lamp</p>
                            <p class="piutang-p-style col-10 m-0">: -</p>
                        </div>
                    </div>
                    <div>
                        <p class="piutang-p-style">Kepada Yth, </p>
                        <p class="piutang-p-style">[{{surat_tagihan.toko.no_acc }}] - {{surat_tagihan.toko.nama_toko }}</p>
                        <p class="piutang-p-style">Dengan Hormat, </p>
                    </div>
                </div>
                <div id="barcode" class="d-flex align-items-center">
                    <qrcode-vue :size="110" :value="surat_tagihan.qr_url" />
                </div>
            </section>
            <section>
                <p class="piutang-p-style pb-3">Melalui Surat ini kami ingin melakukan Konfirmasi Piutang Dagang, yang akan jatuh tempo di Bulan {{dFormat(surat_tagihan.tanggal_surat, 'MY')}}, dengan detail sebagai berikut: </p>
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr class="text-center">
                                <th class="text-dark"  style="font-size: 16px; font-weight: 1000;">KETERANGAN</th>
                                <th class="text-dark"  style="font-size: 16px; font-weight: 1000;">NOMOR</th>
                                <th class="text-dark"  style="font-size: 16px; font-weight: 1000;">TANGGAL</th>
                                <th class="text-dark"  style="font-size: 16px; font-weight: 1000;">TANGGAL JATUH TEMPO</th>
                                <th class="text-dark"  style="font-size: 16px; font-weight: 1000;">TOTAL</th>
                                <th class="text-dark"  style="font-size: 16px; font-weight: 1000;">SISA</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr  v-for="(surat_tagihan, index) in surat_tagihan.details" :key="index" class="text-center">
                                <td class="p-1 style-content-table">INVOICE</td>
                                <td class="p-1 style-content-table">{{ surat_tagihan.no_invoice }}</td>
                                <td class="p-1 style-content-table">{{ dFormat(surat_tagihan.delivered_at, 'dMY') }}</td>
                                <td class="p-1 style-content-table">{{ dFormat(surat_tagihan.due_date , 'dMY') }}</td>
                                <td class="p-1 style-content-table">{{ ribuan(surat_tagihan.grand_total) }}</td>
                                <td class="p-1 style-content-table">{{ ribuan(surat_tagihan.outstanding) }}</td>
                            </tr>
                            <tr>
                                <td colspan="5" class="text-center p-1 style-content-table" style="font-weight: 500;">TOTAL YANG HARUS DIBAYARKAN</td>
                                <td class="text-center p-1 style-content-table" style="font-weight: 500;">{{ribuan(totalSisaPembayaran)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <table>
                    
                </table>
            </section>

            <section class="line-break">
                <p class="piutang-p-style">Kami sangat berharap [{{surat_tagihan.toko.no_acc }}] - {{surat_tagihan.toko.nama_toko }} melakukan pembayaran sesuai dengan tanggal jatuh tempo.</p>
            </section>

            <section class="line-break">
                <p class="piutang-p-style line-break">Pembayaran dapat dilakukan dengan cara transfer ke rekening:</p>
                <table class="mx-5">
                    <tr>
                        <td class="information-bank">Nama Bank</td>
                        <td class="information-bank" style="letter-spacing: 0.4px;">: {{ surat_tagihan.perusahaan.rekenings[0].nama_bank }}</td>
                    </tr>
                    <tr>
                        <td class="information-bank">Nama Akun</td>
                        <td class="information-bank" style="letter-spacing: 0.4px;">: {{ surat_tagihan.perusahaan.rekenings[0].nama_pemilik_rekening }}</td>
                    </tr>

                    <tr>
                        <td class="information-bank">Nomor Akun</td>
                        <td class="information-bank" style="letter-spacing: 0.4px;">: {{ surat_tagihan.perusahaan.rekenings[0].nomor_rekening }}</td>
                    </tr>
                    <tr>
                        <td class="information-bank">Cabang</td>
                        <td class="information-bank" style="letter-spacing: 0.4px;">: {{ surat_tagihan.perusahaan.rekenings[0].cabang_bank }}</td>
                    </tr>
                </table>
            </section>

            <section class="line-break">
                <p class="piutang-p-style line-break">Mohon dapat mengirimkan bukti pembayaran melalui Salesman " {{ timSales }} " untuk melakukan konfirmasi pembayaran.</p>
                <p class="piutang-p-style">Demikianlah surat pemberitahuan yang dapat kami sampaikan, terimakasih atas perhatian dan kerjasamannya.</p>
            </section>

            <section>
                <table>
                    <tbody>
                        <tr>
                            <td class="pb-3 piutang-p-style">Hormat Kami, </td>
                        </tr>
                        <tr>
                            <qrcode-vue :size="110" :value="surat_tagihan.qr_signed" />
                        </tr>
                        <tr>
                            <td class="pt-3 signed_by">{{ surat_tagihan.signed_by}} </td>
                        </tr>
                        <tr>
                            <td class="signed_by">Finance Manager</td>
                        </tr>
                    </tbody>
                </table>
            </section>
        </main>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import helper from "@/assets/js/helper.js";
import QrcodeVue from "qrcode.vue";

export default {
    name: "PrintSuratTagihan",
    components: {
        QrcodeVue,
    },
    data() {
        return {
            surat_tagihan_id: this.$route.params.id
        };
    },
    mixins: [helper],
    computed:{
        ...mapState('surat_tagihan', {
            surat_tagihan: state => state.datas.suratTagihan,
        }),
        totalSisaPembayaran(){
            const sumOutstanding = this.surat_tagihan.details.reduce((sum, detail) => {
                return sum + parseFloat(detail.outstanding);
            }, 0);
            return sumOutstanding.toFixed(0);
        },
        timSales(){
            const tim = this.surat_tagihan.toko.ketentuan_toko.tim;
            const salesman = this.surat_tagihan.toko.ketentuan_toko.tim.salesman.user;
            if (tim && salesman) {
               return  `${tim.nama_tim} - ${salesman.name}`; 
            };
            return ''
        },
        kabupatenCompany(){
            const kode_perusahaan = this.surat_tagihan.perusahaan.kode_perusahaan;
            let kabupaten = "Badung";
            if(['FBN'].includes(kode_perusahaan)){
                kabupaten = "Klungkung"
            }
            return kabupaten
        }
    },
    methods: {
        ...mapActions("surat_tagihan", ["showSuratTagihan"]),
        async _showSuratTagihan(){
            await this.showSuratTagihan(this.surat_tagihan_id)
            if(this.surat_tagihan){
                setTimeout(() => {
                    window.print();
                }, 500);
            }
        }
    },

    created(){
        this._showSuratTagihan()
    },
}
</script>
<style scoped>
    @font-face {
        font-family: 'SR-Pro Display';
        src: url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&display=swap');
    }
    .piutang-main-font{
        font-family: 'SR-Pro Display', sans-serif;
    }
    .line-break{
        padding-bottom: 20px;
    }

    .information-bank{
        font-size: 22px;
        padding-right: 50px; 
        font-weight: 600;
        word-spacing: 4px;
    }
    .signed_by{
        font-size: 21px;
        font-weight: 800;
    }
    .piutang-p-style{
        font-size: 21px;
        margin-bottom: 0px;
        word-spacing: 2px;
    }
    .style-content-table{
        padding: 0px;
        font-size: 18px;
    }
    .print-bg-primary {
        background-color: #2c3c60 !important;
        color: white !important;
    }
</style>